import { Button, Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import {
  CodeValidation,
  codeValidationSchema
} from "pages/Auth/Servicos/ValidadorDocumentos/schema";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { validarDocumento } from "store/modules/servicos/actions/validarDocumento";
import { useQueryParam } from "utils/hooks/useQueryParam";

type FormValidacaoProps = {
  updateIsExpired: (isExpired: boolean) => void;
};

const FormValidacao = ({ updateIsExpired }: FormValidacaoProps) => {
  const [defaultCodigo] = useQueryParam<string>("codigo");
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<CodeValidation>({
    resolver: yupResolver(codeValidationSchema),
    defaultValues: {
      codigo: defaultCodigo || ""
    }
  });

  const dispatch = useAppDispatch();

  const isRequesting = useTypedSelector(
    (state) => state.servicos.validarDocumento.isRequesting
  );

  const showToast = useToast();

  const handleDocumentValidation = (data: CodeValidation) => {
    dispatch(
      validarDocumento({
        codigo: data.codigo,
        onSuccess: (response) => {
          updateIsExpired(!response);

          if (!response) {
            showToast({
              title: "QR Code inválido",
              description:
                "QR Code expirado. Por favor, emita um novo documento atualizado."
            });
          }
        }
      })
    );
  };

  useEffect(() => {
    if (defaultCodigo) {
      handleDocumentValidation({ codigo: defaultCodigo });
    }
  }, [defaultCodigo]);

  return (
    <Flex
      as="form"
      direction="column"
      maxW="1200px"
      mx="auto"
      px="8"
      gap={4}
      onSubmit={handleSubmit(handleDocumentValidation)}
    >
      <Heading fontSize="large">Validação de Documento</Heading>
      <Text>
        Insira abaixo o código de validação impresso no documento para confirmar
        sua autenticidade
      </Text>

      <InputText
        name="codigo"
        label="Código de validação"
        register={register}
        maxLength={12}
        error={errors.codigo}
      />

      <Button
        type="submit"
        isDisabled={isRequesting}
        isLoading={isRequesting}
        loadingText="Validando..."
      >
        Validar Código
      </Button>
    </Flex>
  );
};

export default FormValidacao;
